import Layout from '@/layout/layout'

const elementRouter = {
  path: '/merchant',
  component: Layout,
  redirect: 'noRedirect',
  name: '第三方回收商',
  children: [
    {
      path: 'list',
      component: () => import('@/views/merchant/list/index'),
      name: '商家列表',
      meta: { title: '商家列表', noCache: true }
    },
    // {
    //   path: 'apply',
    //   component: () => import('@/views/merchant/apply/index'),
    //   name: '入驻申请',
    //   meta: { title: '入驻申请', noCache: true }
    // }
  ]
}

export default elementRouter
